__turbopack_context__.v({
  "container": "OtherWorks-module-scss-module__8LcUcq__container",
  "floating": "OtherWorks-module-scss-module__8LcUcq__floating",
  "header": "OtherWorks-module-scss-module__8LcUcq__header",
  "headerItem": "OtherWorks-module-scss-module__8LcUcq__headerItem",
  "hovered": "OtherWorks-module-scss-module__8LcUcq__hovered",
  "itemIndustry": "OtherWorks-module-scss-module__8LcUcq__itemIndustry",
  "itemName": "OtherWorks-module-scss-module__8LcUcq__itemName",
  "itemType": "OtherWorks-module-scss-module__8LcUcq__itemType",
  "itemYear": "OtherWorks-module-scss-module__8LcUcq__itemYear",
  "itemsContainer": "OtherWorks-module-scss-module__8LcUcq__itemsContainer",
  "liveSiteButton": "OtherWorks-module-scss-module__8LcUcq__liveSiteButton",
  "mobileContent": "OtherWorks-module-scss-module__8LcUcq__mobileContent",
  "mobileInfo": "OtherWorks-module-scss-module__8LcUcq__mobileInfo",
  "nameText": "OtherWorks-module-scss-module__8LcUcq__nameText",
  "otherWorks": "OtherWorks-module-scss-module__8LcUcq__otherWorks",
  "rotate": "OtherWorks-module-scss-module__8LcUcq__rotate",
  "trailFade": "OtherWorks-module-scss-module__8LcUcq__trailFade",
  "trailPulse": "OtherWorks-module-scss-module__8LcUcq__trailPulse",
  "underline": "OtherWorks-module-scss-module__8LcUcq__underline",
  "workItem": "OtherWorks-module-scss-module__8LcUcq__workItem",
});
